import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { X, Tag, Brain, ShieldCheck, Users, MousePointerClick, Globe, Store, Star } from 'lucide-react';

const InfoBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Versioning the key in case banner content changes significantly in the future
    const dismissed = localStorage.getItem('infoBannerDismissed_v1.1'); 
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('infoBannerDismissed_v1.1', 'true');
    setIsVisible(false);
  };

  const handleCTAClick = () => {
    navigate('/create-listing');
  };

  if (!isVisible) {
    return null;
  }

  const benefits = [
    { icon: <Tag size={24} className="text-white" />, text: "Shpallje Falas" },
    { icon: <Brain size={24} className="text-white" />, text: "Ndihmë me AI" },
    { icon: <ShieldCheck size={24} className="text-white" />, text: "Transaksione të Sigurta" },
    { icon: <Users size={24} className="text-white" />, text: "Komunitet i Madh" },
    { icon: <MousePointerClick size={24} className="text-white" />, text: "Lehtësi Përdorimi" },
    { icon: <Store size={24} className="text-white" />, text: "Dyqane Profesionale" },
    { icon: <Globe size={24} className="text-white" />, text: "Mbulim i Gjerë" },
  ];

  return (
    <div className="relative bg-gradient-to-r from-green-500 via-teal-500 to-purple-600 text-white p-6 md:p-8 rounded-xl shadow-lg mt-6 mb-4 animate-fade-in">
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 text-white hover:text-gray-200 transition-colors"
        aria-label="Mbyll banerin"
      >
        <X size={24} />
      </button>

      <div className="text-center mb-6">
        <h2 className="text-2xl md:text-3xl font-bold flex items-center justify-center">
          <Star size={28} className="mr-2 text-yellow-300" /> Pse të zgjedhësh TreguIm?
        </h2>
        <p className="text-sm md:text-base opacity-90 mt-1">Platforma jote e besuar për blerje dhe shitje online!</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 mb-6 text-center">
        {benefits.map((benefit, index) => (
          <div key={index} className="flex flex-col items-center p-3 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-300 transform hover:scale-105">
            <div className="mb-2 p-2 bg-white/20 rounded-full">
              {benefit.icon}
            </div>
            <span className="text-xs sm:text-sm font-medium">{benefit.text}</span>
          </div>
        ))}
      </div>

      <div className="text-center">
        <Button
          onClick={handleCTAClick}
          size="lg"
          className="bg-yellow-400 hover:bg-yellow-500 text-slate-800 font-bold px-8 py-3 shadow-md hover:shadow-lg transition-all transform hover:scale-105"
        >
          Krijo Shpallje Tani
        </Button>
      </div>
    </div>
  );
};

export default InfoBanner;
